import React from 'react';

const Loader = (props) => {
  return (
    <div className='loader-wrapper'>
      <div className='loader' />
    </div>
  );
};

export default Loader;
